var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.70801 25C9.31934 25 8.99301 24.868 8.72901 24.604C8.46501 24.34 8.33301 24.0137 8.33301 23.625V16.375C8.33301 15.9863 8.46501 15.66 8.72901 15.396C8.99301 15.132 9.31934 15 9.70801 15H15L20.958 9.042C21.4027 8.59733 21.9097 8.493 22.479 8.729C23.0483 8.965 23.333 9.38867 23.333 10V30C23.333 30.6113 23.0483 31.035 22.479 31.271C21.9097 31.507 21.4027 31.4027 20.958 30.958L15 25H9.70801ZM26.125 26.875V13.042C27.5417 13.5693 28.6807 14.472 29.542 15.75C30.4027 17.028 30.833 18.4447 30.833 20C30.833 21.5833 30.4027 23 29.542 24.25C28.6807 25.5 27.5417 26.375 26.125 26.875Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMedium);
export default __webpack_public_path__ + "static/media/volume-medium.7595b84d0f6ac19ad50ce5185082bf54.svg";
export { ForwardRef as ReactComponent };